import { render } from "./SymptomsPage.vue?vue&type=template&id=02a2069c&scoped=true"
import script from "./SymptomsPage.vue?vue&type=script&lang=js"
export * from "./SymptomsPage.vue?vue&type=script&lang=js"

import "./SymptomsPage.vue?vue&type=style&index=0&id=02a2069c&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a2069c"]])

export default __exports__